import React from "react";
import { Redirect, Route, Switch, useHistory } from "react-router-dom";
import jwtDecode from "jwt-decode";

import {
  AdminsPage,
  DashboardPage,
  HelpPage,
  InvoicePage,
  InvoicesPage,
  NotFoundPage,
  OrganizationProfilePage,
  OrganizationsPage,
  ProfilePage,
  SecurityPage,
  SessionCallPage,
  SessionCompletionPage,
  SessionCallPreviewPage,
  SessionsPage,
  TrainingPage,
  UsersPage
} from "pages";
import { isLogin } from "utils/auth";
import { useUser } from "context/user";
import { logout } from "utils/auth";

export const ProtectedRoutes: React.FC = () => {
  const history = useHistory();
  const { user } = useUser()!;
  const toPath = history.location.pathname;
  if (!isLogin() && toPath !== "/login") {
    history.push(`/login?to=${history.location.pathname}`);
    return <></>;
  }
  if (user.id && user.privs < 1) logout();

  // Check if user has a 2FA setup-only token — force them to /security
  const token = localStorage.getItem("charisma-token");
  if (token) {
    try {
      const decoded: any = jwtDecode(token);
      if (decoded.action === "2fa_setup" && toPath !== "/security") {
        return <Redirect to="/security" />;
      }
    } catch {
      // Invalid token, will be caught elsewhere
    }
  }

  return (
    <>
      <Switch>
        <Route path="/dashboard" component={DashboardPage} />
        <Route path="/training" component={TrainingPage} />
        <Route path="/clients" component={UsersPage} />
        <Route path="/coaches" component={AdminsPage} />
        <Route path="/help" component={HelpPage} />
        <Route path="/profile" component={ProfilePage} />
        <Route path="/security" component={SecurityPage} />
        <Route path="/invoice/:invoiceId" component={InvoicePage} />
        <Route path="/organizations" component={OrganizationsPage} />
        <Route
          path="/organization/:organizationId/invoices"
          component={InvoicesPage}
        />
        <Route
          path="/organization/:organizationId"
          component={OrganizationProfilePage}
        />
        <Route path="/sessions" component={SessionsPage} />
        <Route path="/session/:sessionId/join" component={SessionCallPage} />
        <Route path="/session/:sessionId/completionpage" component={SessionCompletionPage} />
        <Route
          path="/session/:sessionId/preview"
          component={SessionCallPreviewPage}
        />
        <Redirect exact from="/" to="/dashboard" />
        <Route component={() => <NotFoundPage />} />
      </Switch>
    </>
  );
};

export default ProtectedRoutes;
